export default __webpack_public_path__ + "static/media/firm_arrowhead.c94ca177.png";